module.exports = __webpack_public_path__ + "img/D-range.f5706d77.svg";